import Stack from "@mui/material/Stack";
import dynamic from "next/dynamic";
import { ResultFilterUIMode } from "../../../client/swaggerClient"
import getFilterType from "./FilterTypes/FilterType";
import { FindTitleProps } from "./FindDesignTypes";
import { useLayoutData } from "../../../utils/contexts/LayoutContext";
import { useMemo } from "react";
import { useRouter } from "next/router";
import { PageType } from "../../../pages/_app";
import { FindFilterBlockProps } from "./Find.types";

const FindFilterBlock = ({
  filters,
  pageUrl,
  colors
}: FindFilterBlockProps) => {
  const router = useRouter()
  const { mmbr } = router.query
  const { partnerSiteFull, templatePath } = useLayoutData()

  const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath

  const FindTitle = useMemo(() => dynamic<FindTitleProps>(() => import(`../../../design/${path}/_findDesign/Design`).then((style) => style.FindTitle)), [path])

  return (
    <Stack mb={3}>
      {filters.uiMode !== ResultFilterUIMode.CheckBox ? <FindTitle>{filters.title} {filters.subtitle ? <span>{filters.subtitle}</span> : null}</FindTitle> : null}
      <Stack display={"inline-flex"} alignContent={"start"} alignItems={"stretch"} flexDirection={"row"} flexWrap={"wrap"}>
        {filters.uiMode === ResultFilterUIMode.CheckBox ? <FindTitle>{filters.title}</FindTitle> : null}
        {getFilterType(filters, colors, pageUrl, mmbr)}
      </Stack>
    </Stack>
  )
}

export default FindFilterBlock